import "lazysizes";
import "src/utils/i18n";
import "simplebar/src/simplebar.css";
// Fase 3 · El CSS de mapbox, slick, lightbox, quill y draft se importa en
// los componentes que los usan (antes cargaba en el bundle inicial de todos).
import "lazysizes/plugins/attrchange/ls.attrchange";
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom";

ReactDOM.render(<App />, document.getElementById("root"));
